import { createSlice } from '@reduxjs/toolkit';
import { getCampaignAnalytics } from './broadcastAnalyticsThunk';

const broadcastAnalyticsSlice = createSlice({
    name: 'broadcastAnalytics',
    initialState: {
        campaignAnalytics: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCampaignAnalytics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCampaignAnalytics.fulfilled, (state, action) => {
                state.loading = false;
                state.campaignAnalytics = action.payload;
            })
            .addCase(getCampaignAnalytics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch analytics';
            });
    },
});

export default broadcastAnalyticsSlice.reducer;